import {app} from '../../../../../app';
import {Controller} from './manage-policy-apps.controller';

app.component('companyPoliciesAuthenticationAccessPoliciesManage', {
    bindings: {
        companyId: '<',
        defaultPolicy: '<',
        policy: '<',
    },
    controller: Controller,
    templateUrl: require('./manage-policy-apps.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/policies/authentication-access-policies/manage/manage-policy-apps.component.js